"use client";

import type React from "react";
import type { SortOptionKey } from "@/types/sorting";
import { useTranslation } from "react-i18next";

interface SortDropdownProps {
  sortOption: SortOptionKey;
  onSortChange: (option: SortOptionKey) => void;
}

export default function SortDropdown({
  sortOption,
  onSortChange,
}: SortDropdownProps) {
  const { t } = useTranslation();

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSortOption = e.target.value as SortOptionKey;
    onSortChange(newSortOption);
  };

  return (
    <div className="relative w-1/2 md:w-64">
      <select
        className="border border-gray-300 text-[#1C1D1D] text-[16px] font-['Ainslie_Sans'] font-medium py-2 px-3 pr-10 bg-white focus:outline-none w-full appearance-none"
        value={sortOption}
        onChange={handleSortChange}
      >
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="featured"
        >
          {t("sortDropdown.featured")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="best-selling"
        >
          {t("sortDropdown.bestSelling")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="title-asc"
        >
          {t("sortDropdown.alphabeticallyAZ")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="title-desc"
        >
          {t("sortDropdown.alphabeticallyZA")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="price-asc"
        >
          {t("sortDropdown.priceLowToHigh")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="price-desc"
        >
          {t("sortDropdown.priceHighToLow")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="created-asc"
        >
          {t("sortDropdown.dateOldToNew")}
        </option>
        <option
          className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
          value="created-desc"
        >
          {t("sortDropdown.dateNewToOld")}
        </option>
      </select>

      {/* Dropdown icon */}
      <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
        <svg
          className="w-4 h-4 text-gray-500"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
}
